import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import Cookie from 'js-cookie';
import { AUTH_SIGN_URL, DEBUG_APPID, DEBUG_LOCAL, DEBUG_OPENID } from '@/const';
import { getAppIdByGroupId } from '@/services/landing';
import { isWXAppBrowser, qsParse, qsStringify, setSubDomainCookies } from './index';
export function toAuthrize(_a) {
  var appId = _a.appId,
      mode = _a.mode,
      wechatAuthType = _a.wechatAuthType,
      authBizType = _a.authBizType,
      type = _a.type;
  var url = qsStringify({
    type: type || ''
  }); // 重定向地址添加type类型

  var authWechatAppId = appId ? "authWechatAppId=".concat(appId, "&") : '';
  var modeStr = mode ? "mode=".concat(mode, "&") : '';
  var wechatAuthTypeStr = wechatAuthType ? "wechatAuthType=".concat(wechatAuthType, "&") : '';
  var authBizTypeStr = authBizType ? "authBizType=".concat(authBizType, "&") : '';
  var redirectUrl = [AUTH_SIGN_URL, '?', modeStr, authWechatAppId, wechatAuthTypeStr, authBizTypeStr, 'requestUrl=', encodeURIComponent(url)].join(''); // window.location.replace(redirectUrl);

  return redirectUrl;
} // 领课落地页和确认订单页授权处理

export function handleAuth(isLanding) {
  if (isLanding === void 0) {
    isLanding = false;
  }

  return __awaiter(this, void 0, void 0, function () {
    var query, wxAppId, openId, redirect_url, _a, resultCode, data, redirect_url, redirect_url;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          query = qsParse();
          if (!isWXAppBrowser()) return [3
          /*break*/
          , 3];
          wxAppId = Cookie.get('wxAppId');
          openId = Cookie.get('openId'); // 需要识别是否是默认公众号【尽量保持和uc默认公众号一致】
          // 本地调试 不授权，设置默认marketingOpenId

          if (DEBUG_LOCAL) {
            setSubDomainCookies('wxAppId', DEBUG_APPID);
            setSubDomainCookies('marketingOpenId', DEBUG_OPENID);
            return [2
            /*return*/
            , false];
          }

          if (query.groupId && openId && query.type === 'marketing') {
            setSubDomainCookies('marketingOpenId', openId);
            redirect_url = toAuthrize({
              mode: 3,
              wechatAuthType: 2,
              type: 'pay'
            });
            window.location.replace(redirect_url);
            return [2
            /*return*/
            , true];
          } // url地址上包含type===marketing 等于是落地页静默授权方式
          // 避免重复授权


          if (openId && (query.type === 'marketing' || query.type === 'pay')) {
            // setSubDomainCookies('marketingOpenId', openId);
            return [2
            /*return*/
            , false];
          } // openId && wxAppId && !query.groupId存在不再授权
          // openId 和 wxAppId 任何一个不存在，及跳出判断


          if (openId && wxAppId && !query.groupId) {
            return [2
            /*return*/
            , false];
          }

          if (!query.groupId) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , getAppIdByGroupId({
            groupId: query.groupId
          })];

        case 1:
          _a = _b.sent(), resultCode = _a.resultCode, data = _a.data;

          if (resultCode === 200) {
            redirect_url = toAuthrize({
              appId: data,
              mode: 1,
              wechatAuthType: 2,
              authBizType: 2,
              type: 'marketing'
            });
            window.location.replace(redirect_url);
            return [2
            /*return*/
            , true];
          }

          _b.label = 2;

        case 2:
          if (!isLanding || !__store.isHtmlToAuth) {
            redirect_url = toAuthrize({
              mode: 1,
              wechatAuthType: 2,
              authBizType: 2,
              type: 'marketing'
            });
            window.location.replace(redirect_url);
            __store.isHtmlToAuth = false;
            return [2
            /*return*/
            , true];
          } else {
            return [2
            /*return*/
            , true]; // 不展示骨架屏
          }

          _b.label = 3;

        case 3:
          return [2
          /*return*/
          , false];
      }
    });
  });
}